import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { getUserSettings } from '@/api';
import { useMyBets, useReuseBet } from '@/betslip';
import { useTranslations } from '@/i18n/TranslationsProvider';
import { MyBetsPanel } from '@/ui/betslip';

export const Route = createFileRoute('/profile/tickets')({
  component: ProfileTicketsPage,
});

export function ProfileTicketsPage() {
  const { t, i18n } = useTranslation();
  const { selectedLanguage } = useTranslations();
  const navigate = useNavigate();
  const isTranslationReady =
    selectedLanguage === 'en' || i18n.hasResourceBundle(selectedLanguage, 'translation');
  const label = (key: string, fallback: string) =>
    isTranslationReady ? t(key, { defaultValue: fallback }) : fallback;

  const user = getUserSettings();
  const currency = (user?.Currency ?? user?.CurrCode ?? user?.CurrencyCode ?? '').trim();
  const myBets = useMyBets(true);
  const {
    reuseBet,
    isPending: reusePending,
    errorMessage: reuseError,
    clearError: clearReuseError,
    pendingTicketId,
  } = useReuseBet({
    onSuccess: () => {
      void navigate({ to: '/betslip' });
    },
  });

  return (
    <div className="flex flex-col gap-4 lg:gap-6">
      <header className="flex flex-col gap-1 lg:gap-2">
        <h1 className="text-[18px] font-bold text-text-primary lg:text-[22px]">
          {label('My Bets', 'My Bets')}
        </h1>
        <p className="text-[13px] text-text-secondary lg:text-[13px]">
          {label(
            'Open, live, settled, and saved tickets',
            'Open, live, settled, and saved tickets',
          )}
        </p>
      </header>
      <MyBetsPanel
        myBets={myBets}
        currency={currency}
        onReuse={(ticketId) => {
          void reuseBet(ticketId);
        }}
        reusePendingTicketId={reusePending ? pendingTicketId : null}
        reuseError={reuseError}
        onDismissReuseError={clearReuseError}
      />
    </div>
  );
}
